// src/pages/servicos/cadastros/CadastrosServicoPage.js
import React, { useEffect } from 'react';
import { useEquipamentoCliente } from '../../../contexts/servicos/EquipamentoClienteContext';
import { useTipoEquipamento } from '../../../contexts/servicos/TipoEquipamentoContext';
import '../ordensServico/Servicos.css';

const CadastrosServicoPage = () => {
  const { equipamentos, listarEquipamentos, showEquipamentoClienteCad } = useEquipamentoCliente();
  const { tiposEquipamento, listarTiposEquipamento, showTipoEquipamentoCad } = useTipoEquipamento();

  useEffect(() => {
    listarTiposEquipamento();
    listarEquipamentos();
  }, []);

  return (
    <div className="servicos-page container-fluid py-3">
      <h3>Cadastros de serviços</h3>
      <div className="row">
        <div className="col-lg-5">
          <section className="servicos-card">
            <div className="d-flex justify-content-between">
              <h5>Tipos de equipamento</h5>
              <button className="btn btn-sm btn-primary" onClick={() => showTipoEquipamentoCad()}>Novo</button>
            </div>
            <table className="table table-hover">
              <tbody>
                {tiposEquipamento.map(item => (
                  <tr key={item.id}>
                    <td>{item.descricao}</td>
                    <td>{item.ativo ? 'Ativo' : 'Inativo'}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary" onClick={() => showTipoEquipamentoCad(item)}>Editar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </div>
        <div className="col-lg-7">
          <section className="servicos-card">
            <div className="d-flex justify-content-between">
              <h5>Equipamentos dos clientes</h5>
              <button className="btn btn-sm btn-primary" onClick={() => showEquipamentoClienteCad()}>Novo</button>
            </div>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Tipo</th>
                    <th>Equipamento</th>
                    <th>Marca</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {equipamentos.map(item => (
                    <tr key={item.id}>
                      <td>{item.clienteNome}</td>
                      <td>{item.tipoEquipamentoDescricao}</td>
                      <td>{item.descricao}</td>
                      <td>{item.marcaDescricao || '-'}</td>
                      <td>
                        <button className="btn btn-sm btn-outline-primary" onClick={() => showEquipamentoClienteCad(item)}>Editar</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CadastrosServicoPage;
